import React from "react";
import BackToSchedules from "../../../admin/calendar/backtoschedules";

export default function MyScheduleForm({
  openSchedules,
  medium_id,
  schedule_id,
  isCopyType,
  languages,
  countries
}) {
  return (
    <BackToSchedules
    type="medium"
      openSchedules={openSchedules}
      medium_id={medium_id}
      schedule_id={schedule_id}
      isCopyType={isCopyType}
      languages={languages}
      countries={countries}
    />
  );
}
